(() => {
  const active = document.querySelector('.mc-today-offer');
  if (!active) return;
  const zone = 'America/Santiago';
  const dayFormat = new Intl.DateTimeFormat('en-CA',{timeZone:zone,year:'numeric',month:'2-digit',day:'2-digit'});
  const dateFormat = new Intl.DateTimeFormat('es-CL',{timeZone:zone,day:'numeric',month:'long'});
  const getDay = time => dayFormat.format(new Date(time));
  // Find the actual next date boundary, including Chile's DST transitions.
  const nextBoundary = now => {
    const day = getDay(now);
    let low = Math.floor(now / 1000) * 1000, high = low + 27 * 3600000;
    while (high - low > 1000) {
      const mid = Math.floor((low + high) / 2000) * 1000;
      if (getDay(mid) === day) low = mid; else high = mid;
    }
    return high;
  };
  const fields = ['hours','minutes','seconds'].map(unit=>active.querySelector('[data-bb-'+unit+'],[data-tf-'+unit+']'));
  let currentDay = '', boundary = 0, timer;
  const paint = () => {
    const now = Date.now(), day = getDay(now);
    if (day !== currentDay || now >= boundary) {
      currentDay = day;
      boundary = nextBoundary(now);
      const label = active.querySelector('.mc-today-top > span:last-child');
      if (label) label.textContent = dateFormat.format(new Date(now)) + ' · Chile';
    }
    document.documentElement.classList.remove('bx-offer-expired','tf-offer-expired');
    active.hidden = false;
    document.querySelectorAll('.mc-today-ended').forEach(el=>el.hidden=true);
    const seconds = Math.max(0,Math.ceil((boundary-now)/1000));
    [Math.floor(seconds/3600),Math.floor(seconds/60)%60,seconds%60].forEach((value,index)=>{
      const text=String(value).padStart(2,'0');
      if(fields[index]&&fields[index].textContent!==text) fields[index].textContent=text;
    });
  };
  const resume = () => {clearInterval(timer);paint();if(!document.hidden)timer=setInterval(paint,1000);};
  document.addEventListener('visibilitychange',resume);
  window.addEventListener('pageshow',resume);
  resume();
})();


(() => {
  const benefits = {
    '0': '2 sprays para empezar a cuidar tus pies hoy.',
    '1': 'Por $9.000 más que el 2×1, llevas un tercer envase.',
    '2': 'Por $8.000 más que el pack de 3, sumas un cuarto envase.'
  };
  const decorateOffers = () => {
    if (!document.querySelector('.tf-funnel')) return;
    const offers = document.querySelector('#_rsi-cod-form-modal ._rsi-quantity-offers');
    if (!offers) return;
    if (!offers.querySelector('.mc-rsi-heading')) {
      const heading = document.createElement('div');
      heading.className = 'mc-rsi-heading';
      const title = document.createElement('strong');
      title.textContent = 'Elige tu pack y empieza hoy';
      const subtitle = document.createElement('span');
      subtitle.textContent = 'Spray para pies, uñas y entre los dedos · paga al recibir';
      heading.append(title, subtitle);
      offers.prepend(heading);
    }
    offers.querySelectorAll('._rsi-quantity-offers-offer-container').forEach(card => {
      if (card.querySelector('.mc-rsi-benefit')) return;
      const info = card.querySelector('._rsi-quantity-offers-info');
      const benefit = benefits[card.getAttribute('data-offer-pos')];
      if (!info || !benefit) return;
      const text = document.createElement('p');
      text.className = 'mc-rsi-benefit';
      text.textContent = benefit;
      info.append(text);
    });
  };
  let pending = false;
  const relevant = '#_rsi-cod-form-modal, ._rsi-quantity-offers, ._rsi-quantity-offers-offer-container';
  const observer = new MutationObserver(records => {
    if (pending) return;
    const changed = records.some(record => Array.from(record.addedNodes).some(node =>
      node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant))
    ));
    if (!changed) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      decorateOffers();
    });
  });
  observer.observe(document.body, {childList: true, subtree: true});
  decorateOffers();
})();

